import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';

export const startBugsnag = () => {
  if (Bugsnag.isStarted()) return;

  const isValid = ['production', 'staging'].includes(process.env.NEXT_PUBLIC_APP_ENV);
  if (!isValid) return;

  const apiKey = process.env.NEXT_PUBLIC_BUGSNAG_API_KEY;
  if (!apiKey) return;

  const nextIsServer: boolean = isTrue(process.env.NEXT_IS_SERVER);

  // next.js executes top-level code at build time. See https://github.com/vercel/next.js/discussions/16840 for further example
  // So use NEXT_PHASE to avoid Bugsnag.start being executed during the build phase
  // See https://nextjs.org/docs/api-reference/next.config.js/introduction and https://github.com/vercel/next.js/blob/canary/packages/next/shared/lib/constants.ts#L1-L5 for
  // more details on NEXT_PHASE
  if (process.env.NEXT_PHASE !== 'phase-production-build') {
    if (nextIsServer) {
      Bugsnag.start({
        apiKey,
        appVersion: process.env.NEXT_BUILD_ID,
        plugins: [new BugsnagPluginReact()],
        releaseStage: process.env.NEXT_PUBLIC_APP_ENV,
      });
    } else {
      // If preferred two separate Bugsnag projects e.g. a javascript and a node project could be used rather than a single one
      Bugsnag.start({
        apiKey,
        appVersion: process.env.NEXT_BUILD_ID,
        plugins: [new BugsnagPluginReact()],
        releaseStage: process.env.NEXT_PUBLIC_APP_ENV,
      });
      console.log('Bugsnag started !!');
    }
  }
};

const isTrue = (value: unknown): boolean => {
  return value === true || value === 'true';
};
